import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Header } from '../components/Layout/Header';
import { LandingPage } from '../components/Landing';
import { Footer } from '../components/Layout/Footer';

export const HomePage: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect authenticated users to dashboard
  useEffect(() => {
    if (!loading && user) {
      console.log('[HomePage] User is authenticated, redirecting to dashboard');
      navigate('/dashboard', { replace: true });
    }
  }, [loading, user, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-2 border-slate-200 border-t-blue-600 mb-4"></div>
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Loading...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen flex flex-col h-screen overflow-y-auto">
      <Header
        activeAudience="recruiter"
        showLandingNav={true}
      />
      <main className="flex-1">
        <LandingPage activeAudience="recruiter" />
      </main>
      <Footer />
    </div>
  );
};
